export default __webpack_public_path__ + "static/media/line.2bc33353.svg";